import { topbarExcludedViewsForPageType } from '../constants/topbarExcludedViewsForPageType';

export const isViewRestrictedForPageType = (
  pageView: string,
  pageType?: number,
) => {
  const allowedPageTypes = topbarExcludedViewsForPageType[pageView] || [];
  return pageType === undefined || !allowedPageTypes.includes(pageType);
};
